import { triangulateVectors } from '../helpers';

export default function DrawAxes({ vizSize, inputMode }) {
  function Axis({ coords, stroke }) {
    return (
      <line
        x1={vizSize / 2}
        y1={vizSize / 2}
        x2={vizSize / 2 + coords[0]}
        y2={vizSize / 2 + coords[1]}
        stroke={stroke}
      />
    );
  }

  if (inputMode === 'cartesian') {
    return (
      <>
        <line
          x1={0}
          y1={vizSize / 2}
          x2={vizSize}
          y2={vizSize / 2}
          stroke="blue"
        />
        <line
          x1={vizSize / 2}
          y1={0}
          x2={vizSize / 2}
          y2={vizSize}
          stroke="red"
        />
      </>
    );
  }

  return (
    <>
      <Axis
        coords={triangulateVectors({ M1: 500, M2: 0, M3: 0 })}
        stroke={'blue'}
      />
      <Axis
        coords={triangulateVectors({ M1: 0, M2: 500, M3: 0 })}
        stroke={'red'}
      />
      <Axis
        coords={triangulateVectors({ M1: 0, M2: 0, M3: 500 })}
        stroke={'green'}
      />
    </>
  );
}
